import getAxiosInstance from "../common/mhiAxios";
import { UserData, parseUser } from "../user/User";
import qs from "qs";
import { FilterResult, UserFilter } from "./models/UserFilter";

export default {
    getAllUserInfo(): Promise<UserData[]> {
        return getAxiosInstance().get("/api/user-data")
            .then(({data}) => data.map(parseUser))
            .catch((error) => {return error});
    },
    getUserInfo(id: number): Promise<UserData> {
        return getAxiosInstance().get(`/api/user-data/${id}`)
            .then(({data}) => data.map(parseUser))
            .catch((error) => {return error});
    },
    getUserByFilter(filter: UserFilter): Promise<FilterResult> {
        return getAxiosInstance().get("/api/getProfessionalListByConditions", !isNaN(filter.id) && filter.id !== -1 ? {
            params: {
                id: filter.id,
                skill: qs.stringify(filter.skill),
                tag: qs.stringify(filter.tag)
            }
        } : 
            {
                params: {
                    skill: qs.stringify(filter.skill),
                    tag: qs.stringify(filter.tag)
                }
            }
        )
            .then(({data}) => {
                const result: FilterResult = {
                    professionals: data.professionals,
                    skills: data.skills,
                    tags: data.tags,
                };
                return result;
            })
            .catch((error) => {return error;});
    }
};
